/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux';
import BaseDrawer from '../BaseDrawer/BaseDrawer';
import drawerActions from '@/Actions/drawer.actions';
import { Button } from '@/Components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/Components/ui/card';
import inventoryAnalyticsServices from '@/Services/Analytics Services/inventory-analytics.services';
import { urls } from '@/Constants';
import moment from 'moment';
import { useEffect, useState, useRef } from 'react';
import storeServices from '@/Services/Form Services/store.services';
import bell from '@/Images/bell.png';
import { Eye, Plus, RefreshCcw } from 'lucide-react';
import { Tooltip } from '@mui/material';
import { useAuth } from '@/Components/Auth/Login/auth';
import { Chip, Switch } from '@mui/material';
import { Store } from 'lucide-react';
import { LOService, notificationServices } from '@/Services';
import { modalActions } from '@/Actions';
import LeftOverModal from '@/Components/Modals/LeftOverModal/LeftOverModal';
import { LeftOverItemsModal } from '@/Components/Modals/LeftOverItemsModal';
import { showPackagingNotificationtoCustomer } from '@/config/config';

function NotificationDrawer(props) {
    const { handleRefresh = () => { }, loading = false } = props;
    const drawerData = useSelector((state) => state?.drawer?.notificationDrawer);
    const { userConfig = {}, appConfig = {}, userStores = [] } = useAuth()
    const { show, data = {} } = drawerData ?? {};
    // When opened from the "Stores Packaging Pending" badge, surface that section on top.
    const focusPackaging = data?.focus === 'packagingMissing';
    // Packaging notifications are opt-in per customer.
    const showPackaging = showPackagingNotificationtoCustomer.includes(appConfig?.customerId);
    const [stores, setStores] = useState([]);
    const [localLoading, setLocalLoading] = useState(false);
    const loadingTimeoutRef = useRef(null);
    const dispatch = useDispatch();
    const notification = useSelector((state) => state?.wastage?.notification);
    const { list = [], storesNotPunched = [], packagingMissing = [] } = notification;
    const { orders: rawOrders = [], leftOver = [] } = list;
    // Cards ko Expected Delivery Date ke hisaab se DESC dikhao (latest pehle);
    // bina date wale cards sabse neeche.
    const getDeliveryTime = (n) => {
        const m = moment(n?.scheduledAt ?? n?.orders?.[0]?.scheduledAt);
        return m.isValid() ? m.valueOf() : 0;
    };
    const orders = [...rawOrders].sort(
        (a, b) => getDeliveryTime(b) - getDeliveryTime(a)
    );
    const [showNotPunched, setShowNotPunched] = useState(true);
    const totalOrdersCount = orders?.reduce((acc, n) => acc + (n?.orders?.length || 0), 0) || 0;
    const punchedStoresCount = new Set(orders?.flatMap(n => n?.orders?.map(o => o?.toStoreName || o?.storeId))?.filter(Boolean)).size;
    const notPunchedCount = storesNotPunched?.length || 0;
    // Only RETAIL stores punch orders, so the denominator should exclude BASE/WAREHOUSE stores.
    const totalStores = Array.isArray(userStores) ? userStores.filter((s) => s?.storeType === 'RETAIL').length : punchedStoresCount + notPunchedCount;
    const isFalseToggle = appConfig?.customerId == 68 || appConfig?.customerId === 74;
    const handleClose = () => {
        dispatch(drawerActions?.toggleNotificationDrawer(false));
    }
    const { level } = userConfig?.userDetails || {};

    const fetchStores = async () => {
        const req = {
            id: '',
            type: 'RETAIL',
        };
        try {
            const response = await storeServices.getStore(req);
            if (response?.statusCode === 200) {
                setStores(response?.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (show) {
            fetchStores();
            if (isFalseToggle) {
                setShowNotPunched(false)
            } else {
                setShowNotPunched(true);
            }
        }
    }, [show]);

    useEffect(() => {
        if (loading) {
            setLocalLoading(true);
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
        } else {
            loadingTimeoutRef.current = setTimeout(() => {
                setLocalLoading(false);
            }, 800);
        }

        return () => {
            if (loadingTimeoutRef.current) {
                clearTimeout(loadingTimeoutRef.current);
            }
        };
    }, [loading]);

    const fetchPos = async (orderIds = []) => {
        const req = {
            data: {
                filters: {
                    purchaseOrderIds: orderIds,
                },
            },
        };
        try {
            const response = await inventoryAnalyticsServices?.fetchPoList({ req });
            if (response?.statusCode === 200) {
                Object.keys(sessionStorage)
                    .filter((key) => key.startsWith('notificationOrderData_'))
                    .forEach((key) => sessionStorage.removeItem(key));

                const dataKey = `notificationOrderData_${Date.now()}`;
                try {
                    sessionStorage.setItem(dataKey, JSON.stringify(response?.data));
                } catch (storageError) {
                    console.error('Unable to store notification order data:', storageError);
                    return;
                }
                window.open(`${urls?.EXTENSION}${urls?.PRODUCTION_PLANS}?notification=true&orderDataKey=${dataKey}`, '_blank');
            }
        } catch (error) {
            console.log(error, 'error');
        }
    }
    const getTotalStoresLength = (storeId) => {
        return stores?.filter(store => store?.parentStore === storeId && store.type === 'RETAIL')?.length;
    }

    // Open the Primary Packaging Order (sortingOrderSummary) modal preloaded with a
    // destination store's punched orders that still have no packaging order
    // (sortingOrderCreated=false). Mirrors PurchaseOrderList.proceedCreateSortingOrder:
    // kitchen = fromStore of the 1st order, date + shift taken from the orders.
    const handleCreatePackagingOrder = async (storeEntries) => {
        // Accepts a single store entry or the full list — all pending orders are
        // created together in one packaging order (they share one base kitchen).
        const entries = Array.isArray(storeEntries) ? storeEntries : [storeEntries];
        const orderIds = entries
            .flatMap((s) => s?.orders ?? [])
            .map((o) => o?.id)
            .filter((id) => id != null);
        if (orderIds.length === 0) return;
        const req = {
            data: {
                filters: {
                    purchaseOrderIds: orderIds,
                },
            },
        };
        try {
            const response = await inventoryAnalyticsServices?.fetchPoList({ req });
            if (response?.statusCode !== 200) {
                notificationServices.generateNotification({
                    type: 'error',
                    message: response?.errorMessage ?? response?.message ?? 'Could not load orders',
                });
                return;
            }
            // Only orders still missing a packaging order.
            const pendingPOs = (response?.data ?? []).filter((po) => !po?.jsonData?.sortingOrderCreated);
            if (pendingPOs.length === 0) {
                notificationServices.generateNotification({
                    type: 'warning',
                    message: 'Packaging orders already created.',
                });
                return;
            }
            // A packaging order is raised at a single kitchen (fromStore). All the
            // pending orders here share one base kitchen, so use the 1st order's
            // fromStore and include only the orders that share it; if any belong to
            // a different kitchen, let the user know they were left out.
            const firstPO = pendingPOs[0];
            const kitchenId = firstPO?.fromStore;
            const selectedPOs = pendingPOs.filter((po) => po?.fromStore === kitchenId);
            if (selectedPOs.length < pendingPOs.length) {
                notificationServices.generateNotification({
                    type: 'info',
                    message: 'Only orders from the same base kitchen were included. Create the rest from the Sales Order screen.',
                });
            }
            const shiftIds = [...new Set(selectedPOs.map((po) => po?.shiftId).filter((id) => id != null))];
            if (shiftIds.length > 1) {
                notificationServices.generateNotification({
                    type: 'error',
                    message: 'Selected orders span multiple shifts. Please create from the Sales Order screen.',
                });
                return;
            }
            const resolvedShiftId = shiftIds.length > 0 ? shiftIds[0] : null;
            dispatch(modalActions.toggleMultiplePoModal(true, {
                mode: 'sortingOrderSummary',
                navSelectedStore: {},
                selectedPOs,
                summaryMode: true,
                initialState: {
                    kitchen: kitchenId ?? null,
                    date: firstPO?.scheduledAt ? new Date(moment(firstPO.scheduledAt).format('YYYY-MM-DD')) : new Date(),
                    ...(resolvedShiftId != null && { shift: resolvedShiftId }),
                },
            }));
            handleClose();
        } catch (error) {
            console.log(error);
            notificationServices.generateNotification({
                type: 'error',
                message: 'Could not open the packaging order. Please retry.',
            });
        }
    }

    // Punched-but-no-primary-packaging-order stores. Rendered either on top
    // (when the drawer was opened from the packaging badge) or in its default
    // position below the punched orders section.
    const renderPackagingMissing = () => {
        if (!showPackaging) return null;
        if (!(packagingMissing?.length > 0)) return null;
        const totalMissingOrders = packagingMissing.reduce((acc, s) => acc + (s?.orders?.length || 0), 0);
        return (
            <>
                <div className='flex items-center gap-1.5 mb-3'>
                    <h3 className='text-gray-800 text-[14px] font-semibold whitespace-nowrap'>
                        Packaging Orders Pending
                    </h3>
                    <span className='inline-flex items-center justify-center h-5 px-1.5 text-[10px] font-semibold text-amber-800 bg-amber-100 border border-amber-300 rounded-full whitespace-nowrap'>
                        {totalMissingOrders} Orders | {packagingMissing?.length} Stores
                    </span>
                </div>
                <Card className='p-2 rounded-md bg-slate-100 mb-3 border border-slate-600'>
                    <CardContent className='p-2'>
                        <div className='flex flex-wrap gap-2'>
                            {packagingMissing.map((store, idx) => (
                                <Chip
                                    key={store?.storeId || idx}
                                    label={store?.storeName}
                                    size='small'
                                    title={store?.storeName}
                                    className='bg-yellow-200 border border-yellow-800 transition-colors duration-200 shadow-sm font-semibold rounded-md'
                                    style={{ fontSize: '12px', paddingLeft: 6, paddingRight: 6 }}
                                />
                            ))}
                        </div>
                    </CardContent>
                    {level !== 1 && (
                        <CardFooter className='bg-white rounded-md flex flex-col p-3 items-start gap-3'>
                            <div className='flex justify-end w-full'>
                                <Button
                                    className='bg-yellow-500 hover:bg-yellow-600 rounded-md text-black'
                                    onClick={() => handleCreatePackagingOrder(packagingMissing)}
                                >
                                    Create Order
                                </Button>
                            </div>
                        </CardFooter>
                    )}
                </Card>
            </>
        );
    }

    const renderBtns = () => {
        return (
            <Tooltip title='Fetch Notifications'>
                <span>
                    <RefreshCcw
                        size={20}
                        className={`cursor-pointer ${localLoading ? 'animate-spin' : ''} ${localLoading ? 'opacity-50 pointer-events-none' : ''}`}
                        onClick={handleRefresh}
                        disabled={localLoading}
                        style={localLoading ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                    />
                </span>
            </Tooltip>
        )
    }

    const handleLeftOver = (type, data) => {
        if (type === 'add') {
            // handleClose();
            dispatch(modalActions.toggleLeftOverCreateModal(true, {
                ...data,
                invDayEndOf: moment().format('YYYY-MM-DD'),
            }));
        } else {
            handleViewClick(data);
        }
    }
    const handleViewClick = async (data) => {
        try {
            const response = await LOService.listLOInventoryItems({
                id: data?.leftOverId,
            });
            if (response?.statusCode === 200) {
                let itemsData = {};
                const skuType = ['INTERMEDIATE', 'UNPACKED_PRODUCT', 'INGREDIENT'];
                if (Array.isArray(response?.data)) {
                    itemsData = response?.data?.reduce((acc, invItem) => {
                        if (acc?.[invItem?.skuType]) {
                            acc?.[invItem?.skuType]?.push(invItem);
                        } else {
                            acc[invItem?.skuType] = [invItem];
                        }
                        return acc;
                    }, {});
                } else {
                    itemsData = Object?.keys(response?.data)?.reduce((acc, invItem) => {
                        const currentTypeItems = response?.data?.[invItem];
                        acc[invItem] = currentTypeItems?.map((ele) => {
                            return {
                                ...ele,
                                qty: ele?.qty ?? ele?.count,
                                productName: ele?.name,
                                variantName: ele?.variant,
                            };
                        });
                        return acc;
                    }, {});
                }
                const skuTypeWithData = Object.keys(itemsData).filter((ele) => !skuType?.includes(ele));
                const values = skuTypeWithData.flatMap(key => [...itemsData[key]]);
                if (skuTypeWithData?.length > 0) {
                    if (itemsData['INGREDIENT']?.length > 0) {
                        itemsData['INGREDIENT'].push(...values);
                    } else {
                        itemsData['INGREDIENT'] = values;
                    }
                }
                itemsData = {
                    ...(itemsData['INTERMEDIATE'] && { INTERMEDIATE: itemsData['INTERMEDIATE'] }),
                    ...(itemsData['UNPACKED_PRODUCT'] && { UNPACKED_PRODUCT: itemsData['UNPACKED_PRODUCT'] }),
                    ...(itemsData['INGREDIENT'] && { INGREDIENT: itemsData['INGREDIENT'] })
                };
                dispatch(modalActions?.toggleLeftOverItemsModal(true, {
                    heading: `Day End Inventory of ${data?.processName} on ${moment().format('DD-MM-YYYY')}`,
                    items: itemsData,
                    date: moment().format('DD-MM-YYYY'),
                    processName: data?.processName,
                    isApprove: false,
                    advanceBill: false,
                    showTotal: false,
                    showPdf: false,
                    showPoDetails: false,
                    width: '60rem',
                    height: '40rem',
                    excludedColumns: [
                        'Packaged',
                        'Dispatched',
                        'Received',
                        'Returned Quantity',
                        'Fulfilled',
                        'From Process',
                        'PO Id',
                        'Returned',
                        // 'Category Name',
                        'Ordered Quantity',
                        'Item Price',
                        'Tax Percentage',
                        'Tax value',
                        'Total Item Amount',
                        'Discount %',
                        'Used For',
                    ],
                    hideItems: false,
                    isAdvanceBill: false,
                }));
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    return (
        <BaseDrawer
            header={data?.heading || 'Notifications'}
            open={show}
            onClose={handleClose}
            size='xs'
            renderBtns={renderBtns}
        >
            {orders?.length === 0 && leftOver?.length === 0 && storesNotPunched?.length === 0 && (!showPackaging || packagingMissing?.length === 0) && (
                <div className='flex flex-col gap-3 justify-center items-center w-full p-2'>
                    <img src={bell} alt='bell' className='w-28 h-28' />
                    <p className='text-gray-700 text-[14px] items-center'>You're all caught up - no new notifications right now.</p>
                </div>
            )}
            <LeftOverModal handleRefresh={handleRefresh} />
            <LeftOverItemsModal />
            <div className='overflow-y-auto'>
                {focusPackaging && renderPackagingMissing()}
                {(orders?.length > 0 || storesNotPunched?.length > 0) && (
                    <>
                        <div className='flex items-center justify-between gap-2 mb-3'>
                            <div className='flex items-center gap-1.5 min-w-0'>
                                <h3 className='text-gray-800 text-[14px] font-semibold whitespace-nowrap'>
                                    {showNotPunched ? 'Stores Yet to Punch' : 'Orders'}
                                </h3>
                                <span className='inline-flex items-center justify-center h-5 px-1.5 text-[10px] font-semibold text-amber-800 bg-amber-100 border border-amber-300 rounded-full whitespace-nowrap'>
                                    {showNotPunched
                                        ? `${notPunchedCount} / ${totalStores} Stores`
                                        : `${totalOrdersCount} Orders | ${punchedStoresCount} / ${totalStores} Stores`}
                                </span>
                            </div>
                            <Tooltip title={showNotPunched ? 'Showing stores yet to punch order' : 'Showing punched orders'}>
                                <div className='flex items-center gap-0.5 shrink-0'>
                                    <Store size={14} className='text-amber-800' />
                                    <span className='text-[11px] font-medium text-gray-600 whitespace-nowrap'>
                                        {showNotPunched ? 'Not Punched' : 'Punched'}
                                    </span>
                                    <Switch
                                        size='small'
                                        checked={showNotPunched}
                                        onChange={(e) => setShowNotPunched(e.target.checked)}
                                        inputProps={{ 'aria-label': 'Toggle stores yet to punch order' }}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': { color: '#b45309' },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#b45309' },
                                        }}
                                    />
                                </div>
                            </Tooltip>
                        </div>
                        {showNotPunched ? (
                            <Card className='p-2 rounded-md bg-slate-100 mb-3 border border-slate-600'>
                                <CardContent className='p-2'>
                                    {storesNotPunched?.length > 0 ? (
                                        <div className='flex flex-wrap gap-2'>
                                            {storesNotPunched.map((store, idx) => (
                                                <Chip
                                                    key={store?.storeId || idx}
                                                    label={store?.storeName}
                                                    size='small'
                                                    title={store?.storeName}
                                                    className='bg-yellow-200 border border-yellow-800 transition-colors duration-200 shadow-sm font-semibold rounded-md'
                                                    style={{ fontSize: '12px', paddingLeft: 6, paddingRight: 6 }}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        <p className='text-sm text-gray-600 text-center py-2'>All stores have punched their orders.</p>
                                    )}
                                </CardContent>
                            </Card>
                        ) : (
                            orders?.map((notification, idx) => (
                                <Card key={notification.id || idx} className='p-2 rounded-md bg-slate-100 mb-3 border border-slate-600'>
                                    <CardHeader className='border-b'>
                                        <CardTitle className='flex flex-col items-start gap-2 font-medium text-gray-700 mb-2'>
                                            <div className='w-full flex items-center justify-between'>
                                                <span className='text-amber-800 py-0.5 rounded-md font-semibold'>
                                                    {notification?.shiftName}
                                                </span>
                                                <span className='text-[13px] text-nowrap'>
                                                    Expected Delivery Date:
                                                    <span className='text-amber-800 px-2 py-0.5 rounded-md font-semibold'>
                                                        {moment(notification?.scheduledAt ?? notification?.orders?.[0]?.scheduledAt).format('DD-MM-YYYY')}
                                                    </span>
                                                </span>
                                            </div>

                                            <div className='w-full text-sm flex gap-4'>
                                                <div>
                                                    <span>Orders:</span>
                                                    <span className='text-amber-800 px-1 py-0.5 font-semibold'>
                                                        {(notification?.orders ?? []).length}
                                                    </span>
                                                </div>
                                                <div>
                                                    <span>Stores Punched:</span>
                                                    <span className='text-amber-800 px-1 py-0.5 font-semibold'>
                                                        {new Set((notification?.orders ?? []).map(o => o?.toStoreName || o?.storeId).filter(Boolean)).size}/{totalStores}
                                                    </span>
                                                </div>
                                            </div>
                                        </CardTitle>
                                    </CardHeader>
                                    <CardContent>
                                        <div className='flex flex-wrap gap-2'>

                                            {Array.from(
                                                new Map(
                                                    (notification?.orders ?? []).map((order) => [
                                                        order?.toStoreName || notification.message,
                                                        order,
                                                    ])
                                                ).values()
                                            ).map((order, idx) => (
                                                <Chip
                                                    key={order.id || idx}
                                                    label={order?.toStoreName || notification.message}
                                                    size='small'
                                                    title={order?.toStoreName || notification.message}
                                                    className='bg-yellow-200 border border-yellow-800  transition-colors duration-200 shadow-sm font-semibold  rounded-md'
                                                    style={{ fontSize: '12px', paddingLeft: 6, paddingRight: 6 }}
                                                />
                                            ))}
                                        </div>
                                    </CardContent>
                                    {level !== 1 && (
                                        <CardFooter className='bg-white rounded-md flex flex-col p-3 items-start gap-3'>
                                            <p className='text-sm text-gray-700'>
                                                Do you want to create a Production Plan now, or wait for remaining
                                                outlet orders?
                                            </p>
                                            <div className='flex justify-between w-full'>
                                                <Button variant='secondary' className='rounded-md bg-slate-200' onClick={handleClose}>
                                                    No, Wait for Orders
                                                </Button>
                                                <Button className='bg-yellow-500 hover:bg-yellow-600 rounded-md' onClick={() => fetchPos(notification?.orders?.map(order => order?.id))}>
                                                    Yes, Proceed
                                                </Button>
                                            </div>
                                        </CardFooter>
                                    )}
                                </Card>
                            ))
                        )}
                    </>
                )}
                {/* packaging orders missing (default position when not focused from the badge) */}
                {!focusPackaging && renderPackagingMissing()}
                {/* left overs */}
                {leftOver?.length > 0 && (
                    <>
                        <h3 className='text-gray-800 text-[15px] font-semibold items-center'>Left Overs</h3>
                        {leftOver?.map((notification, idx) => (
                            <Card key={notification.id || idx} className='p-2 rounded-md bg-slate-100 mb-3 border border-slate-600'>
                                <CardHeader className='border-b'>
                                    <CardTitle className='flex flex-col items-start gap-2 font-medium text-gray-700 mb-2'>
                                        <div className='w-full flex items-center justify-between'>
                                            <span className='text-[14px] text-nowrap text-amber-800 py-0.5 rounded-md font-semibold'>
                                                {notification?.storeName}
                                            </span>
                                            <div className='flex items-center gap-1 text-sm'>
                                                <span>Left Overs:</span>
                                                <span className='text-amber-800 font-semibold'>
                                                    {notification?.leftOvers?.filter(leftOver => !leftOver?.isLeftOverDone)?.length}/{notification?.leftOvers?.length}
                                                </span>
                                            </div>
                                        </div>
                                    </CardTitle>
                                </CardHeader>
                                {notification?.leftOvers?.map((leftOver, idx) => {
                                    const leftOverData = {
                                        ...leftOver,
                                        StoreId: notification?.storeId,
                                    }
                                    return (
                                        <CardContent>
                                            <div className='w-full justify-between flex items-center gap-2'>
                                                <Chip
                                                    key={leftOver.id || idx}
                                                    label={leftOver?.processName}
                                                    size='small'
                                                    title={leftOver?.processName}
                                                    className='flex-1 bg-yellow-200 font-semibold border border-yellow-200 transition-all duration-200 shadow-sm font-medium rounded-md'
                                                    style={{
                                                        fontSize: '13px',
                                                        padding: '3px 6px',
                                                        maxWidth: '160px',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis'
                                                    }}
                                                />
                                                {level !== 1 ? (
                                                    <Tooltip title={leftOver?.isLeftOverDone ? 'View Left Overs' : 'Add Left Overs'}>
                                                        {leftOver?.isLeftOverDone ? <Eye size={20} className='cursor-pointer' onClick={() => handleLeftOver('view', leftOverData)} /> : <Plus size={20} className='cursor-pointer' onClick={() => handleLeftOver('add', leftOverData)} />}
                                                    </Tooltip>
                                                ) : (
                                                    leftOver?.isLeftOverDone ? (
                                                        <Tooltip title='View Left Overs'>
                                                            <Eye size={20} className='cursor-pointer' onClick={() => handleLeftOver('view', leftOverData)} />
                                                        </Tooltip>
                                                    ) : (
                                                        ''
                                                    )
                                                )}
                                            </div>
                                        </CardContent>

                                    )
                                }
                                )}
                            </Card>
                        ))}
                    </>
                )
                }
            </div >
        </BaseDrawer >
    )
}
export default NotificationDrawer;
